import { styled, Box, Typography } from "@mui/material";

export const InformationCardSection = styled(Box)({
  display: "flex",
  width: "100%",
  flexDirection: "column",
  gap: "16px",
});

export const InformationCardSubTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const InformationCardText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
}));
